export default class CustomMultiSelect {
  constructor(wrapper, filterName) {
    this.wrapper = wrapper;
    this.filterName = filterName;
    this.classNameOpener = "custom-select-opener";
    this.classNameOpen = "is-open";

    // Bind event listeners
    this.initEventListeners();
  }

  initEventListeners() {
    // Handle wrapper clicks
    this.wrapper.addEventListener("click", (event) => this.handleWrapperClick(event));

    // Handle clicks outside
    document.body.addEventListener("click", (event) => this.handleBodyClick(event));

    // Handle clear filter events
    document.addEventListener("click", (event) => this.handleFilterClear(event));
  }

  handleWrapperClick(event) {
    const { target } = event;
    if (target.classList.contains(this.classNameOpener) || target.closest(`.${this.classNameOpener}`)) {
      this.wrapper.classList.toggle(this.classNameOpen);
    }

    if (target.type === "checkbox") {
      this.handleCheckboxParentLogic(target);
      if (this.wrapper.dataset.disableReload !== "true") {
        this.updateFilter();
      }
    }
  }

  handleBodyClick(event) {
    const { target } = event;
    if (!this.wrapper.contains(target)) {
      this.wrapper.classList.remove(this.classNameOpen);
    }
  }

  handleFilterClear(event) {
    const activeFilter = event.target.closest("[data-selector='filter']");
    if (activeFilter) {
      const filterValue = activeFilter.dataset.filter;
      const checkboxFilter = this.wrapper.querySelector(`[data-filter="${filterValue}"]`);
      if (checkboxFilter && checkboxFilter.type === "checkbox") {
        checkboxFilter.checked = false;
        this.updateFilter();
      }
    }
  }

  getValues() {
    return Array.from(this.wrapper.querySelectorAll("input[type='checkbox']:checked")).map(
      (checkbox) => checkbox.value
    );
  }

  handleCheckboxParentLogic(checkbox) {
    const optionDiv = checkbox.closest('.custom-select-option');

    if (optionDiv.classList.contains('custom-select-option--indented') && checkbox.checked) {
      // If a child checkbox is checked, uncheck the parent checkbox
      let sibling = optionDiv.previousElementSibling;
      while (sibling && sibling.classList.contains('custom-select-option--indented')) {
        sibling = sibling.previousElementSibling;
      }

      if (sibling) {
        const parentCheckbox = sibling.querySelector('input[type="checkbox"]');
        if (parentCheckbox && parentCheckbox.checked) {
          parentCheckbox.checked = false;
        }
      }
    }
    else if (!optionDiv.classList.contains('custom-select-option--indented') && checkbox.checked) {
      // If a parent checkbox is checked, uncheck all child checkboxes
      let sibling = optionDiv.nextElementSibling;
      while (sibling && sibling.classList.contains('custom-select-option--indented')) {
        const childCheckbox = sibling.querySelector('input[type="checkbox"]');
        if (childCheckbox && childCheckbox.checked) {
          childCheckbox.checked = false;
        }
        sibling = sibling.nextElementSibling;
      }
    }
  }

  updateFilter() {
    const filterValues = this.getValues();
    const url = new URL(window.location);
    if (filterValues.length > 0) {
      url.searchParams.set(this.filterName, filterValues.join(","));
    } else {
      url.searchParams.delete(this.filterName);
    }
    window.location.assign(url.toString());
  }
}